import { useState, useEffect } from 'react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-200' : 'bg-white/80 backdrop-blur-sm border-b border-gray-100'
      }`}
      style={{ minWidth: '320px' }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* ロゴ */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <img
              src="https://public.readdy.ai/ai/img_res/ca05ad39-7205-4e06-8747-8cc7a6d92761.png"
              alt="株式会社テクノワークス ロゴ"
              className="h-9 sm:h-11 w-auto object-contain"
            />
            <span
              className="text-base sm:text-lg font-bold hidden sm:block whitespace-nowrap"
              style={{ color: '#1A1A1A', letterSpacing: '0.02em' }}
            >
              株式会社テクノワークス
            </span>
          </div>

          {/* 右側：連絡先 */}
          <div className="flex items-center gap-4">
            {/* PC表示 */}
            <div className="hidden md:flex flex-col items-end">
              <span className="text-xs text-gray-500 leading-tight">東京都江東区東雲1-1-1</span>
              <div className="flex items-center gap-1 mt-0.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm" style={{ color: '#2C5AA0' }}></i>
                </div>
                <a
                  href="tel:0312345678"
                  className="text-lg font-bold tracking-wide hover:opacity-75 transition-opacity whitespace-nowrap"
                  style={{ color: '#2C5AA0' }}
                >
                  03-1234-5678
                </a>
              </div>
              <span className="text-xs text-gray-400 leading-tight">平日 8:00〜17:00</span>
            </div>

            {/* スマホ表示：アイコンボタン */}
            <a
              href="tel:0312345678"
              className="flex md:hidden w-10 h-10 items-center justify-center rounded-full border-2 cursor-pointer"
              style={{ borderColor: '#2C5AA0' }}
              aria-label="電話で問い合わせる"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg" style={{ color: '#2C5AA0' }}></i>
              </div>
            </a>

            {/* お問い合わせボタン */}
            <button
              onClick={() => scrollTo('contact')}
              className="hidden sm:block px-4 py-2 text-sm font-semibold rounded-md transition-colors cursor-pointer whitespace-nowrap"
              style={{ backgroundColor: '#2C5AA0', color: '#fff' }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#234d8c')}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#2C5AA0')}
            >
              お問い合わせ
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
